import ActionFile from './ActionFile.component';

export default ActionFile;
